(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define([, "axios"], factory);
	else if(typeof exports === 'object')
		exports["VeTable"] = factory(require("vue"), require("axios"));
	else
		root["VeTable"] = factory(root["Vue"], root["Axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 